export default {
  // getNewActivityDetails: state => state.newActivity,
  // getNewActivityStatus: state => state.newActivityStatus,
  getRecording: state => state.recording,
  getTmpCoords: state => state.tmpCoords,
  getTmpCoordsExt: state => state.tmpCoordsExt,
  getTotalDistance: state => state.totalDistance,
  getSpeed: state => state.speed,
  getTotalSteps: state => state.getTotalSteps
}
